module.exports = __webpack_public_path__ + "img/system-icon.9312757e.svg";